export default [{
  path: '/NewsCenterLatest',//最新动态  厦门动态  志愿者风采 展商风采
  name: 'LatestPage',
  meta: {
    title:'最新动态_新闻中心_中国国际投资贸易洽谈会',
  },
  component: () => import('@/view/NewsCenter/LatestPage.vue')
},{
  path: '/NewsCenterPic',//图片新闻
  name: 'PicPage',
  meta: {
    title:'图片新闻_新闻中心_中国国际投资贸易洽谈会',
  },
  component: () => import('@/view/NewsCenter/PicPage.vue')
},{
  path: '/NewsCenterBoard',//公告板  新闻素材下载   媒体报道
  name: 'BoardPage',
  // meta: {
  //   keepAlive: true,
  // },
  meta: {
    title:'公告板_新闻中心_中国国际投资贸易洽谈会',
  },
  component: () => import('@/view/NewsCenter/BoardPage.vue')
},{
  path: '/NewsCenterLatestDetail',//最新动态详情
  name: 'LatestPageDetail',
  meta: {
    title:'最新动态详情_新闻中心_中国国际投资贸易洽谈会',
  },
  component: () => import('@/view/NewsCenter/LatestPageDetail.vue')
},{
  path: '/NewsCenterORG',//组织机构
  name: 'ORGNewsPage',
  meta: {
    title:'组织机构_新闻中心_中国国际投资贸易洽谈会',
  },
  component: () => import('@/view/NewsCenter/ORGPage.vue')
},{
  path: '/NewsCenterPicDetail',//图片新闻详情
  name: 'PicPageDetail',
  meta: {
    title:'图片新闻详情_新闻中心_中国国际投资贸易洽谈会',
  },
  component: () => import('@/view/NewsCenter/LatestPageDetail.vue')
},{
  path: '/NewsCenterBoardDetail',//公告版详情
  name: 'BoardPageDetail',//
  meta: {
    title:'公告版详情_新闻中心_中国国际投资贸易洽谈会',
  },
  component: () => import('@/view/NewsCenter/LatestPageDetail.vue')//
},{
  path: '/NewsCenterContact',//联系方式
  name: 'contactN',//
  meta: {
    title:'联系方式_新闻中心_中国国际投资贸易洽谈会',
  },
  component: () => import('@/view/NewsCenter/contact.vue')//
},]




// WEBPACK FOOTER //
// ./src/router/newsCenter.js